import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getXeroStatus, accountingApi } from "@/lib/apiClient";
import { XeroCard } from "@/components/XeroCard";
import { AccountingCard, ComingSoonCard } from "@/components/AccountingCard";
import { LedgerRouting } from "@/components/LedgerRouting";

const LIVE = ["freshbooks", "zoho", "sage"];
const SOON = [];

export const AccountingTab = () => {
  const [gen, setGen] = useState(0); // cards re-read after a routing change
  const [rgen, setRgen] = useState(0); // routing re-reads after a connect/disconnect
  const [count, setCount] = useState(null);
  const [params] = useSearchParams();
  const target = params.get("provider");
  const refresh = useCallback(() => Promise.all([getXeroStatus().catch(() => ({})), ...LIVE.map((k) => accountingApi(k).status().catch(() => ({})))]).then((all) => setCount(all.filter((r) => r.connected || r.status === "reauth_required").length)), []);
  useEffect(() => { refresh(); }, [refresh, rgen]);
  useEffect(() => {
    if (count === null || !target) return;
    const t = setTimeout(() => {
      const el = document.querySelector(`[data-testid="${target}-card"]`);
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      el.classList.add("ring-2", "ring-primary", "ring-offset-2", "ring-offset-background");
      el.setAttribute("data-highlighted", "true");
      setTimeout(() => el.classList.remove("ring-2", "ring-primary", "ring-offset-2", "ring-offset-background"), 4000);
    }, 350);
    return () => clearTimeout(t);
  }, [count, target]);
  if (count === null) return null;
  return (
    <div className="space-y-4" data-testid="accounting-tab">
      <p className="text-sm text-muted-foreground">Connect the accounting systems you use. Approved invoices are sent there automatically and payments flow back. {count > 1 ? "With two systems connected, choose below which one each supplier goes to." : "You can connect a second system and route suppliers between them."}</p>
      <LedgerRouting key={`r${rgen}`} onChanged={() => setGen((g) => g + 1)} />
      <XeroCard key={`x${gen}`} onChanged={() => setRgen((g) => g + 1)} />
      {LIVE.map((k) => <AccountingCard key={`${k}${gen}`} provider={k} onChanged={() => setRgen((g) => g + 1)} />)}
      {SOON.length > 0 && <div className="grid gap-3 sm:grid-cols-2">{SOON.map((k) => <ComingSoonCard key={k} k={k} />)}</div>}
    </div>
  );
};
